import {
  SUPABASE_PUBLISHABLE_KEY,
  SUPABASE_URL,
} from "./integrations/supabase/client";

// src/errorReporter.ts
export function initErrorReporter() {
  const IGNORED_ERRORS = [
    /matchMedia.*addEventListener is not a function/i, // iPad iOS12 issue
    /ResizeObserver loop limit exceeded/i, // common harmless warning
    /Login failed: AuthApiError: Invalid login credentials/i, // common harmless warning
  ];

  window.addEventListener("error", (event) => {
    if (IGNORED_ERRORS.some((pattern) => pattern.test(event.message))) {
      console.warn("Ignored error:", event.message);
      event.preventDefault(); // prevent from bubbling up
      return;
    }
    // Otherwise, send to Supabase (your error logger)
    reportError({
      message: event.message,
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error?.stack || null,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const msg = event.reason?.message || String(event.reason);
    if (IGNORED_ERRORS.some((pattern) => pattern.test(msg))) {
      console.warn("Ignored promise rejection:", msg);
      event.preventDefault();
      return;
    }
    reportError({
      message: msg,
      stack: event.reason?.stack || null,
    });
  });

  window.onerror = function (message, source, lineno, colno, error) {
    reportError({
      type: "error",
      message: String(message),
      source,
      lineno,
      colno,
      stack: error?.stack,
      userAgent: navigator.userAgent,
    });
  };

  window.onunhandledrejection = function (event) {
    reportError({
      type: "unhandledrejection",
      message: String(event.reason),
      stack: event.reason?.stack,
      userAgent: navigator.userAgent,
    });
  };

  const originalConsoleError = console.error;
  console.error = function (...args) {
    reportError({
      message: args.map(String).join(" "),
      stack: JSON.stringify(args),
      type: "ConsoleError",
      userAgent: navigator.userAgent,
      source: window.location.href,
    });
    originalConsoleError.apply(console, args);
  };

  // delete window.matchMedia("(prefers-color-scheme: dark)").addEventListener;
  // setTimeout(() => {
  //   throw new TypeError(
  //     "window.matchMedia(...).addEventListener is not a function"
  //   );
  // }, 2000);
}

async function reportError(errorData: any) {
  try {
    const stack = errorData.stack || errorData.error;
    const { file, line, column } = parseStackTrace(stack);

    await fetch(`${SUPABASE_URL}/rest/v1/error_logs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_PUBLISHABLE_KEY,
        Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
      },
      body: JSON.stringify({
        ...errorData,
        stack,
        extra_data: {
          file: file || errorData.source,
          line: line || errorData.lineno,
          column: column || errorData.colno,
          url: window.location.href,
          user_agent: navigator.userAgent,
          app_version: "1.0.0",
          device_info: `${navigator.platform} (${window.innerWidth}x${window.innerHeight})`,
        },
      }),
    });
  } catch (e) {
    console.log("Failed to report error:", e);
  }
}

function parseStackTrace(stack?: string) {
  if (!stack) return {};
  const lines = stack.split("\n");
  for (const line of lines) {
    // Example: "    at MyComponent (http://localhost:5173/src/App.tsx:42:13)"
    const match = line.match(/\(?([^)]+):(\d+):(\d+)\)?$/);
    if (match) {
      return {
        file: match[1],
        line: Number(match[2]),
        column: Number(match[3]),
      };
    }
  }
  return {};
}

async function getClientInfo() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    return await res.json();
  } catch {
    return {};
  }
}
